import { render } from "./Submit.vue?vue&type=template&id=70e6ebf8"
const script = {}
script.render = render

export default script